import { rp } from "./util";

export function Thumb({ src, className = "" }) {
    return src
        ? <div className={`relative overflow-hidden bg-mist/40 ${className}`}><img src={src} alt="" className="absolute inset-0 h-full w-full object-cover" draggable={false} /></div>
        : <div className={`flex items-center justify-center bg-mist/60 text-[10px] uppercase tracking-widest text-neutral-400 ${className}`}>No Photo</div>;
}

export default function ProductTile({ g, img, disabled, onTap }) {
    const stock = g.items.reduce((s, i) => s + i.remaining_qty, 0);
    const prices = g.items.map((i) => i.price);
    const lo = Math.min(...prices), hi = Math.max(...prices);
    const one = g.items.length === 1 ? g.items[0] : null;
    const out = stock <= 0;
    return (
        <button onClick={onTap} disabled={disabled || out} data-testid={`pos-product-${g.key}`}
            className={`group flex flex-col justify-start text-left rounded-md border border-mist bg-white overflow-hidden transition-[transform,border-color] active:scale-[0.98] hover:border-sage-dark disabled:cursor-not-allowed ${out ? "opacity-45" : ""}`}>
            <Thumb src={img} className="aspect-square w-full" />
            <div className="p-2.5 space-y-0.5">
                <p className="text-[13px] font-medium leading-snug text-ink line-clamp-2">{g.title}</p>
                <p className="text-[11px] text-neutral-500 truncate">{one ? one.variant || one.sku : `${g.items.length} variants`}</p>
                <div className="flex items-baseline justify-between gap-2 pt-1">
                    <span className="text-sm font-semibold text-sage-dark">{lo === hi ? rp(lo) : `${rp(lo)}+`}</span>
                    <span className={`text-[11px] ${out ? "text-red-700" : "text-neutral-500"}`} data-testid={`pos-stock-${g.key}`}>{out ? "Sold out" : `${stock} left`}</span>
                </div>
            </div>
        </button>
    );
}
